// Helper web-only para solicitar almacenamiento persistente al navegador (WDUR-04).
// Vive bajo storage/web/ (STOR-05: el boot NO importa esto directo;
// llega via StorageAdapter.requestPersistence()).
//
// IMPORTANTE — esto NO es una garantia de durabilidad. `navigator.storage.persist()`
// solo BAJA la probabilidad de eviction AUTOMATICA; es concesion HEURISTICA por
// navegador (iOS se apoya en contexto PWA/Home-Screen; la elegibilidad de un origen
// Capacitor esta INDOCUMENTADA). La red de cero-perdida real es el sync del outbox al
// servidor (F3/F4). Aqui solo se SOLICITA y se LOGUEA el booleano + el estimate (dev).

/**
 * Solicita almacenamiento persistente y loguea el booleano concedido/denegado.
 * Guarda para navegadores viejos / contextos no-seguros (devuelve false sin lanzar).
 *
 * @returns {Promise<boolean>} true si el navegador concedio persistencia.
 */
export async function requestPersistentStorage () {
  try {
    if (!(navigator.storage && typeof navigator.storage.persist === 'function')) {
      console.info('[offline-v2] navigator.storage.persist() no disponible (navegador viejo / contexto no-seguro)')
      return false
    }

    // Si ya esta concedido, persisted() lo dice sin re-promptear.
    let granted = false
    if (typeof navigator.storage.persisted === 'function') {
      granted = await navigator.storage.persisted()
    }
    if (!granted) {
      granted = await navigator.storage.persist()
    }

    console.info('[offline-v2] navigator.storage.persist() granted =', granted)

    // Observabilidad de cuota en dev (no afecta produccion).
    if (import.meta.env.DEV && typeof navigator.storage.estimate === 'function') {
      try {
        const { usage, quota } = await navigator.storage.estimate()
        console.info('[offline-v2] storage estimate: usage =', usage, 'quota =', quota)
      } catch { /* noop */ }
    }

    return granted
  } catch (error) {
    console.warn('[offline-v2] requestPersistentStorage() fallo:', String(error && error.message ? error.message : error))
    return false
  }
}
